import { render, staticRenderFns } from "./failure.vue?vue&type=template&id=798066f8&scoped=true&"
import script from "./failure.vue?vue&type=script&lang=js&"
export * from "./failure.vue?vue&type=script&lang=js&"
import style0 from "./failure.vue?vue&type=style&index=0&id=798066f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798066f8",
  null
  
)

export default component.exports